import React from 'react';
import { Typography, Progress, Card } from 'antd';
import './style/ServerStat.css';

const { Text } = Typography;

interface ServerStatProps {
    title: string;
    percent: number;
    value?: string; // value теперь опционально
    bgColor: string;
    barColor: string;
}

const ServerStat: React.FC<ServerStatProps> = ({ title, percent, value, bgColor, barColor }) => {
    return (
        <Card
            className="server-stat-card"
            style={{ background: bgColor, borderRadius: 16 }}
            bordered={false}
        >
            <div className="server-stat-content">
                <Text className="server-stat-title">{title}</Text>
                {/* Если value передано, показываем его, иначе - процент */}
                <Text className="server-stat-percent">{value !== undefined ? value : `${percent}%`}</Text>
            </div>
            <Progress
                percent={percent}
                showInfo={false}
                strokeColor={barColor}
                trailColor="#fff"
                style={{ marginTop: 8 }}
                className="server-stat-progress"
                size={{ height: 30 }}
            />
        </Card>
    );
};

export default ServerStat; 